import { Spin } from 'antd';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

const MobileBusinessDashboard = lazy(() => import('../h5/BusinessDashboard'));
const Share = lazy(() => import('../h5/BusinessDashboard/Share'));
const VerificationCode = lazy(() => import('../h5/PhoneLogin/VerificationCode'));
const PhoneLogin = lazy(() => import('../h5/PhoneLogin'));

export const NoLoginRoutes = () => {
  return (
    <Suspense fallback={<SuspenseLoading />}>
      <Routes>
        <Route path="/mobile/business-dashboard" element={<MobileBusinessDashboard />}></Route>
        <Route path="/mobile/share" element={<Share />}></Route>
        <Route path="/mobile/phone-login" element={<PhoneLogin />}></Route>
        <Route path="/mobile/berification-code" element={<VerificationCode />}></Route>
      </Routes>
    </Suspense>
  );
};

export function SuspenseLoading() {
  return (
    <div className="flex justify-center items-center h-[500px]">
      <Spin spinning={true}></Spin>
    </div>
  );
}
